import React from "react";
import { NavLink } from "react-router-dom";

import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';

import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

import Call from "../images/call.png";
import Mail from "../images/mail.png";

import styles from "./styles";
import useGlobal from "../store";
import * as Config from "../helper/Configs";

export default function Header() {
	const classes = styles();
	const [globalState, globalActions] = useGlobal();
	const { contactUs } = globalState.cmsContext;
	const { resorts } = globalState.homeContext;

	const [sidemenu, setSidemenu] = React.useState(false);
	const [hotelsOpen, setHotelsOpen] = React.useState(false);

	const handleMenu = status => event => {
		setSidemenu(status);
	};

	const handleMenuClick = () => {
		setHotelsOpen(!hotelsOpen);
	};

	return (
		<React.Fragment>
			<div>
				<div className={classes.headerWrapper}>
					<div className={classes.menuIcon} onClick={handleMenu(true)}>
						<span></span>
						<span></span>
						<span></span>
					</div>
					<div className={classes.headerlogo}></div>
					<span className="breve h3">
						<a href={`tel:${contactUs.contact}`}>
							<img src={Call} />
							<span className="icon">{contactUs.contact}</span>
						</a>
						<a href={`mailto:${contactUs.email}`}>
							<img src={Mail} />
							<span className="icon">{contactUs.email}</span>
						</a>
					</span>
				</div>
			</div>
		
			<Drawer open={sidemenu} classes={{ paper: classes.drawerRoot }} onClose={handleMenu(false)}>
				<div className={classes.menuImg}>
					<NavLink to="/">
						<img src={`${Config.MEDIA_URL}images/${contactUs.logo}`} />
					</NavLink>
				</div>
				<ul>
					<li onClick={handleMenu(false)}>
						<NavLink to="/">Home</NavLink>
					</li>
					<li onClick={handleMenu(false)}>
						<NavLink to="/about-us">About Us</NavLink>
					</li>
					<li onClick={handleMenuClick}>
						Hotels And Resorts
						{hotelsOpen ? (
							<ExpandLess className={classes.downArrow} />
						) : (
							<ExpandMore className={classes.downArrow} />
						)}
					</li>

					<Collapse in={hotelsOpen} timeout="auto" unmountOnExit>
						<List component="div" disablePadding>
							<ul className={classes.menuDrop}>
								{resorts && resorts.length && (
									resorts.map((resort, key) => (
										<li onClick={handleMenu(false)} key={key}>
											<NavLink to={"/resort/" + resort.slug}>
												<ListItemText secondary={resort.name} classes={{ secondary: classes.subColor }} />
											</NavLink>
										</li>
									)
								))}

							</ul>
						</List>
					</Collapse>
					<li onClick={handleMenu(false)}>
						<NavLink to="/blogs">Blogs</NavLink>
					</li>
					<li onClick={handleMenu(false)}>
						<NavLink to="/careers">Careers</NavLink>
					</li>
					<li onClick={handleMenu(false)}>
						<NavLink to="/gallery">Gallery</NavLink>
					</li>
					<li onClick={handleMenu(false)}>
						<NavLink to="/contact-us">Contact Us</NavLink>
					</li>
				</ul>
			</Drawer>
		</React.Fragment>
	);
}
